var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"scale"}},[_c('div',{class:[
      'animated-checkbox-wrapper',
      'flex-center',
      { 'is-large': _vm.isLarge }
    ],on:{"animationend":_vm.done}},[_vm._t("default"),(_vm.showAnimation)?_c('div',{staticClass:"flex-center"},[_c('svg',{class:['checkmark', { 'is-large-checkmark': _vm.isLarge }],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('circle',{staticClass:"checkmark__circle",attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_c('path',{staticClass:"checkmark__check",attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }